import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { EncountersGame } from './encounters-game.interface';
import { AuthorizationService } from '../services/authorization.service';
import { LegendaryService } from '../services/legendary.service';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@Component({
    selector: 'encounters-form',
    template: require('./encounters-form.component.html'),
    styles: [require('../styles/legendary.css')]
})
export class EncountersFormComponent {
    encountersForm: FormGroup;
    game: EncountersGame;
    loggedIn: boolean = false;
    useCustom: boolean = false;
    windowWidth: number;
    _menuOpen: boolean = true;

    public sideListSelect: Array<string> = [];
    public queenMotherSelect: Array<string> = [];
    public locationListSet: Array<string> = [];
    public locationList: Array<string> = [];
    public objective1ListSet: Array<string> = [];
    public objective2ListSet: Array<string> = [];
    public objective3ListSet: Array<string> = [];
    public objectiveList: Array<string> = [];
    public crewListTeam: Array<string> = [];
    public crewList: Array<string> = [];
    public predatorTeamList: Array<string> = [];

    constructor(private fb: FormBuilder, private auth: AuthorizationService, private legendaryService: LegendaryService) {
        this.loggedIn = auth.isLoggedIn();
        this.windowWidth = document.documentElement.clientWidth;

        this.createForm();
    }

    ngOnInit() {
        this.legendaryService.fetchEncountersControls()
            .subscribe(settings => {
                this.sideListSelect = settings.sideListSelect;
                this.queenMotherSelect = settings.queenMotherSelect;
                this.locationListSet = settings.locationListSet;
                this.locationList = settings.locationList;
                this.objective1ListSet = settings.objective1ListSet;
                this.objective2ListSet = settings.objective2ListSet;
                this.objective3ListSet = settings.objective3ListSet;
                this.objectiveList = settings.objectiveList;
                this.crewListTeam = settings.crewListTeam;
                this.crewList = settings.crewList;
                this.predatorTeamList = settings.predatorTeamList;
            })

        this.legendaryService.fetchEncountersSettings()
            .subscribe(settings => {
                this.encountersForm.patchValue({
                    Players: settings.Players,
                    HiddenAgendas: settings.HiddenAgendas,
                    PlayerAliens: settings.PlayerAliens,
                    OneRipley: settings.OneRipley,
                    SideSetting: settings.SideSetting,
                    QueenMotherMode: settings.QueenMotherMode,
                    EncountersSets: {
                        AlienSet: (settings.LegendarySets.indexOf("AlienSet") > -1) ? false : true,
                        PredatorSet: (settings.LegendarySets.indexOf("PredatorSet") > -1) ? false : true,
                        AlienExpansionSet: (settings.LegendarySets.indexOf("AlienExpansionSet") > -1) ? false : true,
                        CustomSet: (settings.LegendarySets.indexOf("CustomSet") > -1) ? false : true,
                    },
                    ExcludeLocation: settings.ExcludeLocation,
                    ExcludeObjectives: settings.ExcludeObjectives,
                    ExcludeCharacters: settings.ExcludeCharacters,
                    TransmogrifiedLocation: settings.TransmogrifiedLocation,
                    TransmogrifiedObjective1: settings.TransmogrifiedObjective1,
                    TransmogrifiedObjective2: settings.TransmogrifiedObjective2,
                    TransmogrifiedObjective3: settings.TransmogrifiedObjective3,
                    TransmogrifiedCharacter1: settings.TransmogrifiedCharacter1,
                    TransmogrifiedCharacter2: settings.TransmogrifiedCharacter2,
                    TransmogrifiedCharacter3: settings.TransmogrifiedCharacter3,
                    TransmogrifiedCharacter4: settings.TransmogrifiedCharacter4,
                    TransmogrifiedPredator1: settings.TransmogrifiedPredator1,
                    TransmogrifiedPredator2: settings.TransmogrifiedPredator2,
                    TransmogrifiedPredator3: settings.TransmogrifiedPredator3,
                    TransmogrifiedPredator4: settings.TransmogrifiedPredator4
                });
            })
    }

    createForm() {
        this.encountersForm = this.fb.group({
            Players: 2,
            HiddenAgendas: false,
            PlayerAliens: false,
            OneRipley: false,
            SideSetting: "Humanity",
            QueenMotherMode: "None",
            EncountersSets: this.fb.group({
                AlienSet: true,
                PredatorSet: true,
                AlienExpansionSet: true,
                CustomSet: true
            }),
            ExcludeLocation: "",
            ExcludeObjectives: "",
            ExcludeCharacters: "",
            TransmogrifiedLocation: "Random",
            TransmogrifiedObjective1: "Random",
            TransmogrifiedObjective2: "Random",
            TransmogrifiedObjective3: "Random",
            TransmogrifiedCharacter1: "Random",
            TransmogrifiedCharacter2: "Random",
            TransmogrifiedCharacter3: "Random",
            TransmogrifiedCharacter4: "Random",
            TransmogrifiedPredator1: "Random",
            TransmogrifiedPredator2: "Random",
            TransmogrifiedPredator3: "Random",
            TransmogrifiedPredator4: "Random"
        });
    }

    public playersList: Array<{ text: string, value: number }> = [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
    ]

    onSubmit() {
        if (this.windowWidth < 600) {
            this.toggleSidebar();
        }

        this.legendaryService.encountersRandomize(this.encountersForm.value)
            .subscribe((data) => this.game = data as EncountersGame)
    }

      
    public handleLocationFilter(value: string) {
        this.locationListSet = this.locationListSet.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleObjectiveFilter(value: string) {
        this.objectiveList = this.objectiveList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleCharacterFilter(value: string) {
        this.crewList = this.crewList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleToggleSidebar() {
        this.toggleSidebar();
    }

    private toggleSidebar() {
        this._menuOpen = !this._menuOpen;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/encounters/encounters-form.component.ts